"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 12 11';

var Grid = function Grid() {
  return _react["default"].createElement("g", null, _react["default"].createElement("polygon", {
    points: "0 2.607 2.8225 2.607 2.8225 0 0 0"
  }), _react["default"].createElement("polygon", {
    points: "4 2.607 6.8225 2.607 6.8225 0 4 0"
  }), _react["default"].createElement("polygon", {
    points: "8 2.607 10.8225 2.607 10.8225 0 8 0"
  }), _react["default"].createElement("polygon", {
    points: "0 6.607 2.8225 6.607 2.8225 4 0 4"
  }), _react["default"].createElement("polygon", {
    points: "4 6.607 6.8225 6.607 6.8225 4 4 4"
  }), _react["default"].createElement("polygon", {
    points: "8 6.607 10.8225 6.607 10.8225 4 8 4"
  }), _react["default"].createElement("polygon", {
    points: "0 10.607 2.8225 10.607 2.8225 8 0 8"
  }), _react["default"].createElement("polygon", {
    points: "4 10.607 6.8225 10.607 6.8225 8 4 8"
  }), _react["default"].createElement("polygon", {
    points: "8 10.607 10.8225 10.607 10.8225 8 8 8"
  }));
};

var _default = (0, _createSvgIcon["default"])(Grid, {
  viewBox: viewBox
});

exports["default"] = _default;